export default {
    namespaced: true,
    state: {
        storeName: '',
        selectedColumns: [],
        defaultColumns: [],
        allColumns: [],
    },
    mutations: {
        setSelectedColumns(state, columns) {
            state.selectedColumns = columns;

            window.localStorage.setItem(`${state.storeName}.selectedColumns`, JSON.stringify(columns));
        },
    },
    getters: {
        selectedColumns: (state) => Array.from(new Set([...state.selectedColumns])), // Prevents mutation
        shouldShowColumn: (state) => (value) => state.selectedColumns.find((column) => column.value === value),
        allColumns: (state) => state.allColumns,
    },
    actions: {
        setDefaultColumns({ commit, state }) {
            let columns = JSON.parse(window.localStorage.getItem(`${state.storeName}.selectedColumns`));

            if (columns === null) {
                columns = state.defaultColumns;
            }

            commit('setSelectedColumns', columns);
        },
        resetColumns({ commit, state }) {
            commit('setSelectedColumns', Array.from(new Set([...state.defaultColumns]))); // Prevents mutation
        },
        setSelectedColumns({ commit, state }, columns) {
            commit('setSelectedColumns', columns);
        },
        toggleColumn({ commit, state }, column) {
            const selectedColumns = state.selectedColumns;

            const index = selectedColumns.findIndex(selected => selected.value === column.value);
            if (index === -1) {
                selectedColumns.push(column);
            } else {
                selectedColumns.splice(index, 1);
            }

            commit('setSelectedColumns', selectedColumns);
        },
    },
};
